import { set } from 'lodash';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

type CheckProfile = {
  isCompleted?: boolean;
  isGLAAccepted: boolean;
  isInviteChecked: boolean;
  isWelcomeTourCompleted: boolean;
  isNewsTourCompleted: boolean;
  redirectPage?: string;
  appUpdated: boolean;
};

const initialState: CheckProfile = {
  isCompleted: undefined,
  isGLAAccepted: false,
  isInviteChecked: false,
  isWelcomeTourCompleted: false,
  isNewsTourCompleted: false,
  redirectPage: undefined,
  appUpdated: false,
};

const setup = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setCheckProfile(state, { payload }: PayloadAction<CheckProfile>) {
      return payload;
    },
    setProfileCompleted(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isCompleted: payload };
    },
    setGLAAccepted(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isGLAAccepted: payload };
    },
    setInviteChecked(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isInviteChecked: payload };
    },
    setWelcomeTourCompleted(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isWelcomeTourCompleted: payload };
    },
    setNewsTourCompleted(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isNewsTourCompleted: payload };
    },
    setAppUpdated(state, { payload }: PayloadAction<boolean>) {
      return { ...state, appUpdated: payload };
    },
    setRedirectPage(state, { payload }: PayloadAction<string | undefined>) {
      return { ...state, redirectPage: payload };
    },
    clearProfile() {
      return initialState;
    },
  },
});

export const {
  setCheckProfile,
  setProfileCompleted,
  setGLAAccepted,
  setInviteChecked,
  setWelcomeTourCompleted,
  setNewsTourCompleted,
  setRedirectPage,
  setAppUpdated,
  clearProfile,
} = setup.actions;

export const selectIsProfileCompleted = ({ profile }: RootState) =>
  profile.isCompleted;
export const selectIsGLAAccepted = ({ profile }: RootState) =>
  profile.isGLAAccepted;
export const selectIsInviteChecked = ({ profile }: RootState) =>
  profile.isInviteChecked;
export const selectIsWelcomeTourCompleted = ({ profile }: RootState) =>
  profile.isWelcomeTourCompleted;
export const selectIsNewsTourCompleted = ({ profile }: RootState) =>
  profile.isNewsTourCompleted;
export const selectRedirectPage = ({ profile }: RootState) =>
  profile.redirectPage;
export const selectAppUpdated = ({ profile }: RootState) => profile.appUpdated;

export default setup.reducer;
